const MICROSECONDS_PER_MILLISECOND = 1000;
const MILLISECONDS_PER_SECOND = 1000;
const MILLISECONDS_PER_MINUTE = 60 * MILLISECONDS_PER_SECOND;
const MILLISECONDS_PER_HOUR = 60 * MILLISECONDS_PER_MINUTE;

export function formatSrtTime(microseconds: number): string {
  let milliseconds = Math.round(microseconds / MICROSECONDS_PER_MILLISECOND);
  if (!Number.isFinite(milliseconds) || milliseconds < 0) {
    milliseconds = 0;
  }

  const hours = Math.floor(milliseconds / MILLISECONDS_PER_HOUR);
  milliseconds -= hours * MILLISECONDS_PER_HOUR;

  const minutes = Math.floor(milliseconds / MILLISECONDS_PER_MINUTE);
  milliseconds -= minutes * MILLISECONDS_PER_MINUTE;

  const seconds = Math.floor(milliseconds / MILLISECONDS_PER_SECOND);
  milliseconds -= seconds * MILLISECONDS_PER_SECOND;

  return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(seconds, 2)},${pad(milliseconds, 3)}`;
}

function pad(value: number, size: number): string {
  return String(value).padStart(size, "0");
}
